import { createSlice } from "@reduxjs/toolkit";
import { ISelectOption } from "src/@types/form";
import { getIndustriesReducer, getIndustryReducer } from "./reducers";
import { INDUSTRIES_SLICE_NAME } from "./actions";

interface IIndustryObject<T> {
  isLoading: boolean;
  data: T;
}

export interface IIndustriesState {
  industries: IIndustryObject<ISelectOption[]>;
  industry: IIndustryObject<ISelectOption>;
}

const initialState: IIndustriesState = {
  industries: {
    isLoading: false,
    data: [],
  },
  industry: {
    isLoading: false,
    data: null,
  },
};

export const { reducer: industries } = createSlice({
  name: INDUSTRIES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getIndustriesReducer(builder);
    getIndustryReducer(builder);
  },
});
